import React from 'react'

import FieldValidationMessage from '../field-validation-message/index.jsx'

import './styles.scss'

const ValidatedForm = ({ inputs }) => {
  return (
    <div className="validated-form">
      {inputs.map(
        ({ label, render, required, show = true, validationClassName }) =>
          show && (
            <div key={label} className="validated-form__row">
              <div className="validated-form__column">
                <div className="validated-form__row">{render()}</div>
                <If condition={required}>
                  <FieldValidationMessage fieldName={label} className={validationClassName} />
                </If>
              </div>
            </div>
          )
      )}
    </div>
  )
}

export default ValidatedForm
